import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const canDoColumns = (intl = null, es = false) => [
  {
    className: "companyName",
    dataIndex: "companyName",
    key: "companyName"
  },
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Può firmare"}) || "Può firmare",
    dataIndex: "firma",
    key: "firma",
    render: (firma) =>
      firma === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  !es ? {
    className: "dataColumn",
    title: "Autorizza pagamenti e scadenze",
    dataIndex: "pagamentiScadenze",
    key: "pagamentiScadenze",
    render: (pagamentiScadenze) =>
      pagamentiScadenze === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  } : {},
  !es ? {
    className: "dataColumn",
    title: "Autorizza scadenze fiscali e previdenziali",
    dataIndex: "autorizzaFiscali",
    key: "autorizzaFiscali",
    render: (autorizzaFiscali) =>
      autorizzaFiscali === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  } : {},
  {
    className: "dataColumn",
    title: intl?.formatMessage({id: "permissions.Autorizza disposizioni di pagamento"}) || "Autorizza disposizioni di pagamento",
    dataIndex: "autorizzaDisposizioni",
    key: "autorizzaDisposizioni",
    render: (autorizzaDisposizioni) =>
      autorizzaDisposizioni === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  },
  !es ? {
    className: "dataColumn",
    title: "Vede scadenze create da fatture",
    dataIndex: "scadenzeFatture",
    key: "scadenzeFatture",
    render: (scadenzeFatture) =>
      scadenzeFatture === true ? (
        <FontAwesomeIcon
          icon={["fas", "check-circle"]}
          style={{
            color: "#09822a",
            fontSize: "14px"
          }}
        />
      ) : (
        <FontAwesomeIcon
          icon={["fas", "minus-circle"]}
          style={{
            color: "#d82829",
            fontSize: "14px"
          }}
        />
      )
  } : {}
];
